import React, { useEffect, useState, useRef } from 'react';
import ReactDOM from 'react-dom';

import Popup from '@/components/Popup/index.jsx';
import Paper from '@/pages/components/dialog/paper';

import Btn from '../../btn';
import imgFlower from '@/assets/images/wish/paperFlower.png';
import imgFooter from '@/assets/images/wish/envelope.png';

import { GET_RANDOM_WISH,HELP_WISH } from '@/services/wish';
import ShowAlert from '@/pages/components/dialog/alert';
import {SEND_DATE} from '@/utils';

import styles from './index.less';

import imgBtnNext from '@/assets/images/btn/btnNext.png';
import imgBtnGet from '@/assets/images/btn/btnGet.png';


const GetWish=(props)=>{
  const {destory} = props;
  const [wish,setWish] = useState(null);
  const init= async ()=>{
    const req = await GET_RANDOM_WISH();
    if(req?.code==0){
      if(req.data==null){
        ShowAlert({label:'来晚啦',text:'心愿已全部被认领\n下次早点来哦！',btnLabel:'好的'});
        destory(false);
        return;
      }
      setWish(req.data);
    }else{
      destory(false);
    }
  }
  useEffect(()=>{
    init();
  },[])
  const onOk= async ()=>{
    const req = await HELP_WISH({wish_id:wish.id});
    if(req?.code==0){
      const toPage = await ShowAlert({label:'感谢认领',text:`请于${SEND_DATE}，自行寄送心愿礼物\n寄送地址在「我的领取」详情中查看`,btnLabel:'查看寄送地址'});
      if(toPage){
        destory(req.data);
      }else{
        destory(false);
      }
      return;
    }else if(req?.code==1){
      ShowAlert({label:'来晚啦',text:'当前心愿已被别人领取啦！',btnLabel:'好的'});
    }else{
      ShowAlert({label:'注意',text:req?.msg,btnLabel:'好的'});
    }
    destory(false)
  }
  const onClose=()=>{
    destory(false)
  }
  const onNext= ()=>{
    destory('change');
  }
  if(!wish)return <></>
  return (
    <section className={styles.center}>
      <section className={styles.wrap}>
        <Paper wish={wish} />
        <img className={styles.footer} src={imgFooter} />
        <img className={styles.flower} src={imgFlower} />
        {/* <Btn label='help' className={styles.btn} onClick={onOk} /> */}
        <section className={styles.btnsWrap}>
          <img src={imgBtnNext} className={styles.btnNext} onClick={onNext} />
          <img src={imgBtnGet} className={styles.btnGet} onClick={onOk} />
        </section>
        <div className={styles.close} onClick={onClose} />
        
      </section>
    </section>
  )
}

const ShowGetWish=(props)=>{
  return new Promise(resolve=>{
    let popup = Popup(resolve);
    ReactDOM.render(
      <GetWish destory={popup.destory}  />,
      popup.dom
    );
  })
}

export default ShowGetWish;